import { render, staticRenderFns } from "./mt-basics.vue?vue&type=template&id=2658e056&scoped=true"
import script from "./mt-basics.vue?vue&type=script&lang=js"
export * from "./mt-basics.vue?vue&type=script&lang=js"
import style0 from "./mt-basics.vue?vue&type=style&index=0&id=2658e056&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2658e056",
  null
  
)

export default component.exports